import { render, staticRenderFns } from "./processes-tab.vue?vue&type=template&id=5a2f571f"
import script from "./processes-tab.vue?vue&type=script&lang=js"
export * from "./processes-tab.vue?vue&type=script&lang=js"
import style0 from "./processes-tab.vue?vue&type=style&index=0&id=5a2f571f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports